module.exports = new __parcel__URL__("singular.f2f97098.png").toString();